import { render, staticRenderFns } from "./PosSearch.vue?vue&type=template&id=3cd88a76"
import script from "./PosSearch.vue?vue&type=script&lang=js"
export * from "./PosSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports